import React, { useState } from 'react';
import DashboardLayout from '../components/DashboardLayout';
import SimpleApiExplorer from '../components/SimpleApiExplorer';
import './PageStyles.css';

const ReceiverMode = () => {
  const [showTryApi, setShowTryApi] = useState(false);
  const receiverModes = [
    { id: 1, code: 'BANK_ACCOUNT', name: 'Bank Account', description: 'Transfer to bank account', status: 'Active', requiredFields: ['account_number', 'routing_number', 'bank_name'] },
    { id: 2, code: 'MOBILE_WALLET', name: 'Mobile Wallet', description: 'Transfer to mobile wallet', status: 'Active', requiredFields: ['wallet_number', 'wallet_provider'] },
    { id: 3, code: 'CASH_PICKUP', name: 'Cash Pickup', description: 'Cash pickup at agent location', status: 'Active', requiredFields: ['receiver_name', 'receiver_phone', 'pickup_location'] },
    { id: 4, code: 'HOME_DELIVERY', name: 'Home Delivery', description: 'Cash delivery to receiver address', status: 'Active', requiredFields: ['receiver_name', 'receiver_phone', 'delivery_address'] },
  ];

  const sampleRequest = {
    code: "DIGITAL_WALLET",
    name: "Digital Wallet",
    description: "Transfer to digital wallet",
    status: "active",
    required_fields: ["wallet_id", "wallet_type"]
  };

  const sampleResponse = {
    status: "success",
    code: "200",
    message: "Receiver mode created successfully",
    data: {
      id: 5,
      code: "DIGITAL_WALLET",
      name: "Digital Wallet",
      description: "Transfer to digital wallet",
      status: "active",
      required_fields: ["wallet_id", "wallet_type"],
      created_at: "2024-01-15T10:30:00Z"
    },
    request_id: "req_123456789"
  };

  const getListResponse = {
    status: "success",
    code: "200",
    data: [
      { id: 1, code: "BANK_ACCOUNT", name: "Bank Account", description: "Transfer to bank account", status: "active" },
      { id: 2, code: "MOBILE_WALLET", name: "Mobile Wallet", description: "Transfer to mobile wallet", status: "active" },
    ],
    request_id: "req_123456789"
  };

  const receiverModesTabs = [
    { id: 'get', label: 'Get', method: 'GET', endpoint: '/api/v1/receiver-modes', sampleResponse: getListResponse },
    { id: 'add', label: 'Add', method: 'POST', endpoint: '/api/v1/receiver-modes', sampleRequest, sampleResponse },
  ];

  return (
    <DashboardLayout>
      <div className="page-container">
        <div className="card">
          <div className="card-header card-header-master">
            <h2>Receiver Modes</h2>
            <button type="button" className="btn btn-try-api" onClick={() => setShowTryApi(true)}>
              Try API
            </button>
          </div>
          
          <table className="table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Code</th>
                <th>Name</th>
                <th>Description</th>
                <th>Required Fields</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {receiverModes.map((mode) => (
                <tr key={mode.id}>
                  <td>{mode.id}</td>
                  <td><code>{mode.code}</code></td>
                  <td><strong>{mode.name}</strong></td>
                  <td>{mode.description}</td>
                  <td>{mode.requiredFields.join(', ')}</td>
                  <td>
                    <span className={`status-badge ${mode.status.toLowerCase()}`}>
                      {mode.status}
                    </span>
                  </td>
                  <td>
                    <button className="btn btn-secondary btn-sm">Edit</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {showTryApi && <div className="try-api-sidebar-overlay" onClick={() => setShowTryApi(false)} aria-hidden="true" />}
        {showTryApi && (
          <aside className="try-api-sidebar">
            <SimpleApiExplorer
              apiName="Receiver Modes API"
              tabs={receiverModesTabs}
              onClose={() => setShowTryApi(false)}
            />
          </aside>
        )}
      </div>
    </DashboardLayout>
  );
};

export default ReceiverMode;
